import { combineReducers } from "redux";
import assetConfiguratorReducer from "./configurator/reducers";

const assetReducer = combineReducers({
  configurator: assetConfiguratorReducer
});

export default assetReducer;
